import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import TasksContextCard from 'components/organisms/Cards/TasksContextCard/TasksContextCard';

const StyledEntityTasksContextCard = styled(TasksContextCard)` 
  ${ComponentStyles}
`;

StyledEntityTasksContextCard.propTypes = {
  theme: PropTypes.object
};

export default StyledEntityTasksContextCard;
